<mat-dialog-content class="preferences">
  <div style="display: flex;">
    <div style="width: 100%">
      <h1 style="font-size: 1.5rem; margin-bottom: 2rem;">Ollie Settings</h1>
    </div>
  </div>

  @if (loading) {
    <lib-content-loader></lib-content-loader>
  }

    @for (option of options; track option.option_id) {
      <div class="preferences-form">
        <mat-card
          class="preferences-card"
          style="cursor: pointer;"
          appearance="outlined"
          (click)="preferenceSelection(option)">

          <mat-card-content
            [class.disabled]="!this.preferences[0].has_assessment && option.option_id === 1">
            @if (option.value) {
              <mat-icon class="checkmark" color="primary">check</mat-icon>
            }
              {{ option.option_name }}
          </mat-card-content>
         </mat-card>
      </div>
    }

    <div class="subtext">
      <p>
        <strong> Use Every Style </strong>gives you a question in every style for a well-rounded approach.
      </p>
      <p>
        <strong> Use My Assessment </strong>gives more questions in your lower styles to help you improve.
        <em> Requires a RESPECT Coaching Styles Assessment.</em>
      </p>
    </div>


  <mat-dialog-actions style="gap: 0.8rem; padding-right: 0rem" align="end">
    <lib-button color="primary" (click)="saveSelection()" mat-button mat-dialog-close>Done</lib-button>
  </mat-dialog-actions>
</mat-dialog-content>
